import React from 'react';
import ReactDOM from 'react-dom';
import { Container, Wrapper } from './styled';
import { SidebarWrapperProps } from './types';

const Component: React.FC<SidebarWrapperProps> = ({ children, open }) => (
  <Wrapper data-testid="sidebar-wrapper" open={open}>
    <Container>
      <>{children}</>
    </Container>
  </Wrapper>
);

export const SidebarWrapper: React.FC<SidebarWrapperProps> = ({ ...props }) => {
  const target = document.getElementById('page-wrapper');
  return target ? ReactDOM.createPortal(Component(props), target) : null;
};
